// Types
import type { TManagerCompanyAlias } from '~/modules/manager/types';

export const useManagerCompanyAliasesInput = () => {
  const inputValue: Ref<string> = ref<string>('');
  const list: Ref<TManagerCompanyAlias[]> = ref<TManagerCompanyAlias[]>([]);
  const error: Ref<string> = ref<string>('');

  const setInputValue = (value: string) => {
    inputValue.value = value;
  };

  const setList = (aliases: TManagerCompanyAlias[]) => {
    list.value = [...aliases];
  };

  const setError = (value: string) => {
    error.value = value;
  };

  const addItem = (selectedItem: TManagerCompanyAlias) => {
    const isDuplicated: boolean = !!list.value.find(
      (item: TManagerCompanyAlias) => item.id === selectedItem.id
    );

    if (isDuplicated) {
      setError('Alias already selected');

      return;
    }

    list.value.unshift(selectedItem);

    setInputValue('');
  };

  const deleteItem = (selectedItem: TManagerCompanyAlias) => {
    list.value = [...list.value].filter(
      (item: TManagerCompanyAlias) => item.id !== selectedItem.id
    );
  };

  watch(inputValue, () => setError(''));

  return {
    inputValue,
    list,
    error,
    setList,
    addItem,
    deleteItem,
  };
};
